module.exports = __webpack_public_path__ + "static/media/53_KTC_shortcut.c63538c8.png";